/* index.js */

'use strict';
const Steve = require('@gluenetworks/steve_core').getInstance();

const TwoTierLayout = require('./src/layoutcomponents/TwoTierLayoutComponent');
Steve.di.registry.register('LayoutManagers.TwoTierLayout', TwoTierLayout);
